document.addEventListener('bundler:loaded', function () {
  if (typeof window.bndlr === 'undefined' || typeof window.bndlr.getBundles !== 'function') {
    console.error('Bundler not available');
    return;
  }

  document.querySelectorAll('[data-product-id]').forEach((productCard) => {
    const productId = parseInt(productCard.getAttribute('data-product-id'));
    const originalPrice = parseFloat(productCard.getAttribute('data-product-price'));

    const allBundles = window.bndlr.getBundles();
    let highestDiscount = 0;

    for (const bundle of allBundles) {
      if (bundle.is_volume_bundle == 'true') {
        if (bundle.products[productId] !== undefined) {
          let volumeDiscounts = bundle.volume_discounts;

          volumeDiscounts.forEach((discount) => {
            if (discount.discount_type === 'percentage') {
              highestDiscount = Math.max(highestDiscount, parseFloat(discount.discount_value));
            }
          });
        }
      }
    }

    highestDiscount = highestDiscount / 100;

    const lowestPrice = originalPrice * (1 - highestDiscount);

    const originalPriceElement = productCard.querySelector('.original-price');
    const lowestPriceElement = productCard.querySelector('.lowest-price');
    const fromElement = productCard.querySelector('.from-price');

    if (highestDiscount > 0) {
      if (originalPriceElement && lowestPriceElement) {
        // originalPriceElement.classList.add('hidden');
        lowestPriceElement.classList.remove('hidden');
        fromElement.classList.remove('hidden');

        const priceSpan = lowestPriceElement.querySelector('[data-excl-price]');
        if (priceSpan) {
          priceSpan.textContent = formatMoney(lowestPrice);
          priceSpan.setAttribute('data-excl-price', lowestPrice);
        }
      }
    }
  });
});

function formatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '€{{amount}}';

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, '.');
    decimal = defaultOption(decimal, ',');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}
